import EnquiryForm from '@/components/EnquiryForm'
import React from 'react'
import { Col } from 'react-bootstrap'
import SpeakToUsForm from '@/components/Forms/SpeakToUsForm'

const SpeakToUs = () => {
	return (
		<EnquiryForm>
			<Col className='speak-to-wapper'>
				<p className='seack-to-us-heading'>Get in Touch</p>
				<p className='seack-to-us-description'>
					World's leading online marketplace aimed at transforming the Metal supply chain, Recycling, and Fabrication segments with managed
					logistics & finance solutions.
				</p>
			</Col>
			<Col>
				<div className='speak-to-us-form'>
					<SpeakToUsForm type='buying' />
				</div>
			</Col>
		</EnquiryForm>
	)
}

export default SpeakToUs
